export default __webpack_public_path__ + "static/sounds-95e15da913d932b487d7fad61954a95c.png";